var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notify-box"},[_c('CustomNotifications',{attrs:{"notifications":_vm.notifications.notifications},on:{"remove-notification":_vm.removeNotification}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }